export default __webpack_public_path__ + "static/media/Dust.40421d9a.png";